'use strict';

/*
    TabsNavigation

    Constructs tab elements for the top tray view in
    the member portal.

    Programmatic initialization of this component is highly recommended.

    JS initialization:
        $(selector).mogo().create("TabsNavigation", {
          ...arguments...
        });

    Arguments:
      IE:
        tabObj = [{
              title: 'Title',
              url: '/member/dashboard/...'
            },
            {
              title: 'Title 2',
              url: '/member/dashboard/...'
            }

        tabs (required) [object]:
            A composite object that describes the tab item of the tab navigation.

    Methods (see methods for additional usage):

    addTabItem( tabObj, injectBefore)

    removeTabItem (index)

    setEnable (index)

    setActive (index)

    setDisable (index)
*/

function TabsNavigation() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.tabs = null;
  this.product = null;
  // Priority, load this component before the page (default page is at 2000).
  // the lower the value, the higher the priority
  this.priority = 800;

  this._history = null;

  this._classes = {
    container: 'tabs-navigation__container',
    btnWrapper: 'tabs-navigation__btn-wrapper',
    tab: 'tabs-navigation__btn',
    anchor: 'tabs-navigation__anchor',
    active: 'tabs-navigation__btn--active',
    disable: 'tabs-navigation__btn--disable',
    indicator: 'app-alerts__indicator',
    elongated: 'tabs-navigation__container--elongated'
  };

  this._listItems = [];

  this.init = function () {
    if (!this.tabs) return console.error('No tab items were passed through');

    // Add Class
    $(this.node).addClass(this._classes.container);

    // Get History
    this._history = new History();

    // Setup structure
    this._setupTabStructure();
    this.setActive();
    this._eventHandlers();

    $(this.node).show();
  };

  this.initAllReady = function () {};

  // Generate tab wrapper
  this._setupTabStructure = function () {
    this._$tabWrapper = $('<ul>', {
      class: this._classes.btnWrapper,
      role: 'tablist',
      'aria-label': 'Tabs Navigation'
    });

    // Append to the DOM one time after structure is complete
    this._$tabWrapper.appendTo(this.node);

    // Generate tab element by looping this.tabs
    for (var i = 0; i < this.tabs.length; i++) {
      if (i < 6) {
        this.addTabItem(this.tabs[i]);
      } else {
        console.error('TabsNavigation: Maximum 6 tabs allowed: Will not render title ' + this.tabs[i].title);
      }
    }
  };

  /* 
    Adds a tab item to the tab navigation.
     Arguments:
      tabObj[object](required):
      The tab object that describes the tab navigation menu to be added.
      see example tabObj below.
      
      IE:
      tabObj = [{
         title: 'Title',
         url: '/member/dashboard/...'
       },
       {
         title: 'Title 2',
         url: '/member/dashboard/...'
       }
      
    insertBefore[integer](optional):
      The index to insert the tab item to. If not specified, inserts the menu
      item at the end of the tab navigation.
     Returns:
      true if successful, false otherwise.
  */

  this.addTabItem = function (tabObj, insertBefore) {
    // insertBefore index check
    if (insertBefore > this._listItems.length - 1) insertBefore = null;

    // Title and URL are required
    if (typeof tabObj.title === 'string' && typeof tabObj.url === 'string') {
      var tab = $('<li>', {
        class: this._classes.tab,
        role: 'tab',
        tabindex: 0,
        'aria-controls': tabObj.ariaControls,
        'aria-selected': false
      });

      // tabindex to -1 so for no tabbing
      var anchor = $('<a />', {
        class: this._classes.anchor,
        href: tabObj.url,
        text: tabObj.title,
        tabindex: -1,
        'data-analytics-id': tabObj.analyticsId ? tabObj.analyticsId : (this.product ? this.product + '-' : '') + 'Navigation-' + tabObj.title + '-Navigation-Component'
      });

      // indicator
      var indicator = $('<sup />', {
        class: this._classes.indicator
      });

      // indicator accessibility text
      var a11y_text = $('<div />', {
        class: 'a11y__hidden-content',
        text: '(requires attention)'
      });

      // Set link
      anchor[0].setAttribute('href', tabObj.url);

      // Append nodes to their containers
      $(tab).html(anchor);
      anchor[0].appendChild(indicator[0]);
      indicator[0].appendChild(a11y_text[0]);

      // Add to listItems as a reference
      if (insertBefore == null) {
        this._listItems.push(tab);
      } else {
        this._listItems.splice(insertBefore, 0, tab);
      }

      // Add extension class when there are more than 3 items
      if (this._listItems.length > 3) $(this.node).addClass(this._classes.elongated);

      if (insertBefore == null) {
        $(tab).appendTo(this._$tabWrapper);
      } else {
        var tabs = $(this.node).find('.' + this._classes.tab);
        $(tab).insertBefore($(tabs[insertBefore]));
      }

      return true;
    }
    console.error('TabsNavigation: could not create item, missing title or url');

    return false;
  };

  this._eventHandlers = function () {
    var _this = this;

    this._$anchors = $(this.node).find('.' + this._classes.anchor);
    this._$tabs = $(this.node).find('.' + this._classes.tab);

    // Tab list event listener
    this._$tabWrapper.on('click', function (e) {
      e.preventDefault();
      var path = window.location.pathname;
      var nextUrl = null;
      if (e.target.tagName === 'A') {
        nextUrl = e.target.getAttribute('href');
      } else {
        nextUrl = e.target.firstChild.getAttribute('href');
      }

      if (path !== nextUrl && nextUrl != null) {
        _this._history.goToUrl(nextUrl);
      }
    });

    // Tab event listener
    this._$tabWrapper.on('keydown', function (e) {
      if (e.which === 13) {
        $(e.target).click();
      } else {
        var currentActive = $('[aria-selected="true"]', this._$tabWrapper)[0];
        if (e.which === 37) {
          if (currentActive.previousSibling) {
            $(currentActive.previousSibling).focus();
            $(currentActive.previousSibling).click();
          }
        } else if (e.which === 39) {
          if (currentActive.nextSibling) {
            $(currentActive.nextSibling).focus();
            $(currentActive.nextSibling).click();
          }
        }
      }
    });

    // Popstate/pushstate handlers
    this._setActiveBinded = this.setActive.bind(this);
    window.addEventListener('pushstate', this._setActiveBinded);
    window.addEventListener('popstate', this._setActiveBinded);
  };

  /*
    Sets a tab item to active. Text is white and color border
     Arguments:
        index [integer] (required):
            The index of the tab item to be Active.
     Returns:
        true if successful, false otherwise.
  */

  this.setActive = function (index) {
    var currentPath = window.location.pathname;
    var tabs = $(this.node).find('.' + this._classes.tab);

    // Remove all classes
    tabs.removeClass(this._classes.active).attr('aria-selected', false);

    if (Number.isInteger(index)) {
      // Select specific Tab
      $(tabs[index]).addClass(this._classes.active).attr('aria-selected', true);
    } else {
      var currentTab = tabs.filter(function (i, tab) {
        return tab.children[0].pathname === currentPath || tab.children[0].pathname === currentPath + '/';
      })[0];

      // URL not tab URL
      if (currentTab) {
        currentTab.classList.add(this._classes.active);
        currentTab.setAttribute('aria-selected', true);
      }
    }
  };

  /*
    Sets a tab item to enable. Clickable, not greyed out
     Arguments:
        index [integer] (required):
            The index of the tab item to be enabled.
     Returns:
        true if successful, false otherwise.
  */

  this.setEnable = function (index) {
    var tabs = $(this.node).find('.' + this._classes.tab);

    if (Number.isInteger(index)) {
      $(tabs[index]).removeClass(this._classes.disable);
      this.setActive();
      return true;
    }
    return false;
  };

  /*
    Sets a tab item to disable. None clickable, greyed out
     Arguments:
        index [integer] (required):
            The index of the tab item to be disabled.
     Returns:
        true if successful, false otherwise.
     TODO: css for disabled design
  */

  this.setDisable = function (index) {
    var tabs = $(this.node).find('.' + this._classes.tab);

    if (Number.isInteger(index)) {
      $(tabs[index]).removeClass(this._classes.active).addClass(this._classes.disable);
      return true;
    }
    return false;
  };

  /*
    Removes a tab item.
     Arguments:
        index [integer] (required):
            The index of the tab item to be removed.
     Returns:
        true if successful, false otherwise.
  */

  this.removeTabItem = function (index) {
    var tabs = $(this.node).find('.' + this._classes.tab);

    if (Number.isInteger(index)) {
      $(tabs[index]).remove();
      this._listItems.splice(index, 1);
      if (this._listItems.length <= 3) $(this.node).removeClass(this._classes.elongated);
      return true;
    }
    return false;
  };

  /*
    Adds orange indicator to tab item.
      Arguments:
        index [integer] (required):
            The index of the tab item that indicator should be added to.
      Returns:
        true if successful, false otherwise.
  */
  this.addIndicator = function (index) {
    var tabs = $(this.node).find('.' + this._classes.indicator);
    if (index >= tabs.length) return false;

    if (Number.isInteger(index)) {
      $(tabs[index]).addClass('show');
      return true;
    }
    return false;
  };

  /*
    Removes orange indicator to tab item.
      Arguments:
        index [integer] (required):
            The index of the tab item that indicator should be removed from.
      Returns:
        true if successful, false otherwise.
  */

  this.removeIndicator = function (index) {
    var tabs = $(this.node).find('.' + this._classes.indicator);

    if (index >= tabs.length) return false;

    if (Number.isInteger(index)) {
      $(tabs[index]).removeClass('show');
      return true;
    }
    return false;
  };

  this.destroy = function () {
    window.removeEventListener('pushstate', this._setActiveBinded);
    window.removeEventListener('popstate', this._setActiveBinded);
  };
}